export { default } from "./Odds";
